import React from 'react';

import { filterCaseStudies } from '../../../../lib/helpers';
import Pagination from '../../Pagination/Pagination';
import CaseStudyList from './CaseStudyList';

const CaseStudyTemplate = ({
    posts,
    allPosts,
    pageContext,
    isGroup,
    showFilter,
    filterQuery,
    slug = 'case-studies',
    location
}: {
    posts: any;
    allPosts?: [];
    pageContext: any;
    isGroup?: boolean;
    showFilter?: boolean;
    filterQuery?: string;
    slug?: string;
    location?: any;
}) => {
    const businessUnitList = allPosts ? Array.from(
        allPosts?.edges.map((edge: any, i: number) => {
            return edge.node.field_business_unit_string;
        })) : null;

    if (!location) {
        return (
            <CaseStudyList
                posts={posts.edges}
                pageContext={pageContext}
                businessUnitList={businessUnitList}
                pages={pageContext.numberOfPages}
                currentPage={pageContext.currentPage}
                isGroup={isGroup}
                slug={slug}
            />
        );
    }

    const { search } = location;
    const queryFilter = new URLSearchParams(search).get('businessUnits');
    const filteredPosts = queryFilter && queryFilter !== 'all' ? filterCaseStudies(allPosts?.edges, queryFilter, 'case_study') : null;
    const results = filteredPosts ? filteredPosts : posts.edges;

    return (
        <>
            <CaseStudyList
                posts={results}
                pageContext={pageContext}
                filterQuery={queryFilter ? queryFilter : undefined}
                businessUnitList={businessUnitList}
                pages={pageContext.numberOfPages}
                currentPage={pageContext.currentPage}
                isGroup={isGroup}
                showFilter={showFilter}
                slug={slug}
            />

            {((pageContext && !queryFilter) ||
                (pageContext && queryFilter === 'all')) && (
                    <Pagination pageContext={pageContext} slug={slug} background="white" />
                )}
        </>
    );
};

export default CaseStudyTemplate;
